import { render, staticRenderFns } from "./NewUsers.vue?vue&type=template&id=49f6cc5a&scoped=true&"
import script from "./NewUsers.vue?vue&type=script&lang=js&"
export * from "./NewUsers.vue?vue&type=script&lang=js&"
import style0 from "./NewUsers.vue?vue&type=style&index=0&id=49f6cc5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6cc5a",
  null
  
)

export default component.exports